import { render } from "./wednesday-morning.vue?vue&type=template&id=45e693c2"
import script from "./wednesday-morning.vue?vue&type=script&lang=js"
export * from "./wednesday-morning.vue?vue&type=script&lang=js"
script.render = render

export default script